import { render, staticRenderFns } from "./VeracruzCarater.vue?vue&type=template&id=ab04b8d6&scoped=true"
import script from "./VeracruzCarater.vue?vue&type=script&lang=ts"
export * from "./VeracruzCarater.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab04b8d6",
  null
  
)

export default component.exports